import TagsSelect from './tags-select'
export default TagsSelect
